// client/src/components/crowdfunding/ParentalConsent.tsx

import React, { useState } from "react";
import { submitParentalConsent } from "../../services/crowdfundingService"; // Assumes this function is implemented
import "../../assets/styles/crowdfunding.css";

// Define the props for the component: applicationId is required.
interface ParentalConsentProps {
  applicationId: string;
}

const ParentalConsent: React.FC<ParentalConsentProps> = ({ applicationId }) => {
  const [parentName, setParentName] = useState<string>("");
  const [consentGiven, setConsentGiven] = useState<boolean>(false);
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!parentName || !consentGiven) {
      setError("Parent's name and consent are required.");
      return;
    }

    setError(null);
    setLoading(true);

    // Prepare the payload including the applicationId.
    const payload = {
      parentName,
      consent: consentGiven,
      applicationId, // Added required property
    };

    try {
      // Call the backend service to submit consent.
      const response = await submitParentalConsent(payload);
      console.log("Parental consent submitted:", response);
      setSubmitted(true);
    } catch (err: any) {
      setError(err.message || "Failed to submit consent.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="parental-consent">
      <h2>Parental Consent</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {submitted ? (
        <p style={{ color: "green" }}>Consent submitted successfully!</p>
      ) : (
        <form onSubmit={handleSubmit}>
          <div>
            <label>Parent/Guardian Name:</label>
            <input
              type="text"
              value={parentName}
              onChange={(e) => setParentName(e.target.value)}
              placeholder="Enter your name"
              required
            />
          </div>
          <div>
            <label>
              <input
                type="checkbox"
                checked={consentGiven}
                onChange={(e) => setConsentGiven(e.target.checked)}
              />
              I hereby give my consent for the application.
            </label>
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit Consent"}
          </button>
        </form>
      )}
    </div>
  );
};

export default ParentalConsent;
